@if(isLoggedIn) {
<nav class="navbar navbar-expand-lg bg-body-tertiary">
  <div class="container-fluid">
    <a class="navbar-brand" routerLinkActive="active" routerLink="/home" style="margin-right: 0;"> <img
        src="assets/images/favicon.png">
      @if(isLoggedIn) { <span class="casi-name-text"> User: {{me!.fullName}}</span> }</a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="mb-2 mb-lg-0 ms-auto navbar-nav">
        @if(isLoggedIn){

        <!-- <li class="nav-item">
          <a class="nav-link" routerLinkActive="active" routerLink="/chat">Chat Test</a>
        </li> -->

        <li class="nav-item">
          <a class="nav-link" routerLinkActive="active" routerLink="/projectsummary">Project Summary and Releases</a>
        </li>

        <li class="nav-item">
          <a class="nav-link" routerLinkActive="active" routerLink="/project-tracker">Project Tracker</a>
        </li>

        <li class="nav-item">
          <a class="nav-link" routerLinkActive="active" routerLink="/userstories">User Stories</a>
        </li>


        <!-- <li class="nav-item">
          <a class="nav-link" routerLinkActive="active" routerLink="/tracker">Tracker</a>
        </li> -->

        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Manage
          </a>
          <ul class="dropdown-menu">
            <li><a class="dropdown-item" routerLinkActive="active" routerLink="/projects">Projects</a></li>
            <li><a class="dropdown-item" routerLinkActive="active" routerLink="/admin-enquires-list">Enquiries</a></li>
            <!-- <li><a class="dropdown-item" routerLinkActive="active" routerLink="/user-databases">User Database</a></li>
            <li>
              <hr class="dropdown-divider">
            </li>
            <li><a class="dropdown-item" routerLinkActive="active" routerLink="/database-updates">Database Updates</a>
            </li>
            <li>
              <hr class="dropdown-divider">
            </li>
            <li><a class="dropdown-item" routerLinkActive="active" routerLink="/user-database-updates">User Database
                Updates</a></li> -->
          </ul>
        </li>
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Users
          </a>
          <ul class="dropdown-menu">
            <li><a class="dropdown-item" routerLinkActive="active" routerLink="/permissions">Permissions</a></li>
            <li><a class="dropdown-item" routerLinkActive="active" routerLink="/roles">Roles</a></li>
            <li>
              <hr class="dropdown-divider">
            </li>
            <li><a class="dropdown-item" routerLinkActive="active" routerLink="/users">Users</a></li>
          </ul>
        </li>
        }
        @if(isLoggedIn){
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Setup
          </a>
          <ul class="dropdown-menu">
            <!-- <li><a class="dropdown-item" routerLinkActive="active" routerLink="/settings">Settings</a></li>
            <li>
              <hr class="dropdown-divider">
            </li> -->
            <li><a class="dropdown-item" routerLinkActive="active" routerLink="/controlparams">Control Parameters</a>
            </li>
            <!--  <li>
              <hr class="dropdown-divider">
            </li>
             <li>
              <a class="dropdown-item" routerLinkActive="active" routerLink="/about">About</a>
            </li> -->
          </ul>
        </li>
        }
        <!-- <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Tests
          </a>
          <ul class="dropdown-menu">
            <li><a class="dropdown-item" routerLinkActive="active" routerLink="/testCsvImport">Test Csv Import</a></li>
            <li><a class="dropdown-item" routerLinkActive="active" routerLink="/test1">Test 1</a></li>
            <li><a class="dropdown-item" routerLinkActive="active" routerLink="/test2">Test 2</a></li>
            <li><a class="dropdown-item" routerLinkActive="active" routerLink="/testgrid">Test Grid</a></li>
            <li><a class="dropdown-item" routerLinkActive="active" routerLink="/testgridmenu">Test Grid Menu</a></li>
          </ul>
        </li> -->
        @if(isLoggedIn){
        <li class="nav-item">
          <button type="button" class="nav-link active btn" (click)="signOut()">Sign Out</button>
        </li>
        } @else {
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="active" routerLink="/login">Login</a>
        </li>
        }
      </ul>
    </div>
  </div>
</nav>
} @else {
<!-- <div class="main"> -->

<div class="container-fluid no-padding main">

  <div class="top-banner d-none d-lg-block">
    <h2 class="top-header d-none d-lg-block">Data Transformation <span class="blue-font">Hub</span></h2>
    <a class="navbar-brand" routerLink="/home-logged-out" class="top-logo">
      <img src="assets/images/casi-logo.png" class="top-img"></a>
  </div>
</div>
<!-- </div> -->
<nav class="navbar navbar-expand-lg bg-body-tertiary d-none d-lg-block" style="margin-bottom: 0;">
  <div class="container-fluid">
    <!-- <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
      data-bs-target="#casi-tracker-navbar-collapse" aria-controls="casi-tracker-navbar-collapse" aria-expanded="false"
      aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button> -->
    <div class="collapse navbar-collapse" id="casi-tracker-navbar-collapse">
      <!-- <a class="navbar-brand" href="#">Hidden brand</a> -->
      <ul class="navbar-nav mx-auto">
        <li class="nav-item"><a class="nav-link active" routerLinkActive="active" routerLink="/home-logged-out"
            fragment="aboutSection">ABOUT US </a>
        </li>
        <li>
          <div class="navbar-text">/</div>
        </li>
        <li class="nav-item" routerLinkActive="active"><a class="nav-link active" routerLinkActive="active"
            routerLink="/home-logged-out" fragment="peopleSection">OUR
            PEOPLE</a>
        </li>
        <li>
          <div class="navbar-text">/</div>
        </li>
        <li class="nav-item" routerLinkActive="active"><a class="nav-link active" routerLinkActive="active"
            routerLink="/home-logged-out" fragment="servicesSection">OUR
            SERVICES</a>
        </li>
        <li>
          <div class="navbar-text">/</div>
        </li>
        <li class="nav-item" routerLinkActive="active"><a class="nav-link active" routerLinkActive="active"
            routerLink="/home-logged-out" fragment="approachSection">OUR
            APPROACH</a>
        </li>
        <li>
          <div class="navbar-text">/</div>
        </li>
        <li class="nav-item" routerLinkActive="active"><a class="nav-link" routerLinkActive="active"
            routerLink="/home-logged-out" fragment="examplesSection">OUR
            PROJECTS</a>
        </li>
        <li>
          <div class="navbar-text">/</div>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="active" routerLink="/contact-us">CONTACT US</a>
        </li>
        <li>
          <div class="navbar-text">/</div>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="active" routerLink="/login">LOGIN</a>
        </li>
      </ul>

    </div>
  </div>
</nav>
<nav class="navbar navbar-expand-lg bg-body-tertiary d-lg-none d-xl-none d-xxl-none top-banner-small"
  style="margin-bottom: 0;">
  <div class="container-fluid">
    <a class="navbar-brand" routerLink="/home-logged-out">
      <img src="assets/images/casi-logo.png" class="top-img">
    </a>
    <div class="btn-group dropstart">
      <button class="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
        <span class="navbar-toggler-icon"></span>
      </button>
      <ul class="dropdown-menu">
        <li class="dropdown-item"><a class="nav-link active" routerLinkActive="active" routerLink="/home-logged-out"
            fragment="aboutSection">ABOUT US </a>
        </li>
        <li class="dropdown-item"><a class="nav-link active" routerLinkActive="active" routerLink="/home-logged-out"
            fragment="peopleSection">OUR PEOPLE</a>
        </li>
        <li class="dropdown-item"><a class="nav-link active" routerLinkActive="active" routerLink="/home-logged-out"
            fragment="servicesSection">OUR SERVICES</a>
        </li>
        <li class="dropdown-item"><a class="nav-link active" routerLinkActive="active" routerLink="/home-logged-out"
            fragment="approachSection">OUR APPROACH</a>
        </li>
        <li class="dropdown-item"><a class="nav-link active" routerLinkActive="active" routerLink="/home-logged-out"
            fragment="examplesSection">OUR PROJECTS</a>
        </li>
        <li class="dropdown-item">
          <a class="nav-link" routerLinkActive="active" routerLink="/contact-us">CONTACT US</a>
        </li>
        <li class="dropdown-item">
          <a class="nav-link" routerLinkActive="active" routerLink="/login">LOGIN</a>
        </li>
      </ul>

    </div>
    <!-- <div class="btn-group dropstart">
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
        data-bs-target="#casi-tracker-navbar-collapse" aria-controls="casi-tracker-navbar-collapse"
        aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="casi-tracker-navbar-collapse">
        <ul class="navbar-nav dropdown-menu">
          <li class="dropdown-item"><a class="nav-link active" routerLinkActive="active" routerLink="/home-logged-out"
              fragment="aboutSection">ABOUT US </a>
          </li>
          <li class="dropdown-item"><a class="nav-link active" routerLinkActive="active" routerLink="/home-logged-out"
              fragment="peopleSection">OUR PEOPLE</a>
          </li>
          <li class="dropdown-item"><a class="nav-link active" routerLinkActive="active" routerLink="/home-logged-out"
              fragment="servicesSection">OUR SERVICES</a>
          </li>
          <li class="dropdown-item"><a class="nav-link active" routerLinkActive="active" routerLink="/home-logged-out"
              fragment="approachSection">OUR APPROACH</a>
          </li>
          <li class="dropdown-item"><a class="nav-link active" routerLinkActive="active" routerLink="/home-logged-out"
              fragment="examplesSection">OUR PROJECTS</a>
          </li>
          <li class="dropdown-item">
            <a class="nav-link" routerLinkActive="active" routerLink="/contact-us">CONTACT US</a>
          </li>
          <li class="dropdown-item">
            <a class="nav-link" routerLinkActive="active" routerLink="/login">LOGIN</a>
          </li>
        </ul>
      </div>

    </div> -->

  </div>
</nav>
}
